// extracted by mini-css-extract-plugin
module.exports = {"container":"_1975ce1","link":"_c03c9b5"};